/**
 * Generate a URL-friendly slug from a name and ID.
 * Format: "some-title-here-123" where 123 is the ID.
 * The ID is always the last segment after the final hyphen.
 */
export function slugify(name, id) {
  const slug = (name || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
  return slug ? `${slug}-${id}` : `${id}`
}

/**
 * Extract the numeric ID from a slug.
 * The ID is the last number after the final hyphen.
 */
export function idFromSlug(slug) {
  if (!slug) return null
  const match = slug.match(/(\d+)$/)
  return match ? match[1] : slug
}

/** Build event URL */
export function eventPath(event) {
  return `/events/${slugify(event.name, event.id)}`
}

/** Build event edit URL */
export function eventEditPath(event) {
  return `/events/${slugify(event.name, event.id)}/edit`
}

/** Build new sale URL */
export function newSalePath(event) {
  return `/events/${slugify(event.name, event.id)}/sales/new`
}

/** Build sale URL */
export function salePath(event, sale) {
  return `/events/${slugify(event.name, event.id)}/sales/${slugify(sale.title || sale.name, sale.id)}`
}

/** Build sale edit URL */
export function saleEditPath(event, sale) {
  return `/events/${slugify(event.name, event.id)}/sales/${slugify(sale.title || sale.name, sale.id)}/edit`
}
